export interface FaqItem {
  question: string;
  answer: string;
}

export const faqItems: FaqItem[] = [
  {
    question: 'Czym jest Kakobuy Spreadsheet?',
    answer: 'Kakobuy Spreadsheet to uporządkowany arkusz produktów, który pomaga użytkownikom szybciej znajdować interesujące produkty z chińskich platform zakupowych. Zawiera posegregowane kategorie, linki do produktów oraz przydatne informacje ułatwiające podejmowanie decyzji zakupowych.'
  },
  {
    question: 'Czy Kakobuy Spreadsheet jest darmowy?',
    answer: 'Tak, arkusze Kakobuy Spreadsheet są dostępne bezpłatnie. Możesz przeglądać listy produktów, kategorie i rekomendacje bez żadnych opłat. To narzędzie stworzone, aby ułatwić użytkownikom dostęp do najlepszych okazji zakupowych.'
  },
  {
    question: 'Jak znaleźć najlepsze produkty w arkuszu?',
    answer: 'Najlepsze produkty możesz znaleźć, korzystając z kategorii i filtrów dostępnych w arkuszu. Zacznij od wybrania interesującej Cię kategorii (np. buty, odzież, akcesoria), a następnie przeglądaj polecane pozycje. Każdy produkt zawiera bezpośredni link do źródła.'
  },
  {
    question: 'Czy istnieją alternatywy dla Kakobuy Spreadsheet?',
    answer: 'Tak, istnieją alternatywne arkusze, takie jak CSSBuy Spreadsheet, Superbuy Spreadsheet czy Oopbuy Spreadsheet. Każda platforma ma swoje unikalne cechy — niektóre oferują więcej kategorii, inne lepsze filtrowanie. Warto porównać je wszystkie, aby znaleźć najlepsze rozwiązanie dla siebie.'
  },
  {
    question: 'Czy CSSBuy Spreadsheet działa podobnie do Kakobuy?',
    answer: 'CSSBuy Spreadsheet działa na podobnej zasadzie co Kakobuy — oferuje uporządkowane listy produktów z podziałem na kategorie. Różnice dotyczą głównie interfejsu, liczby dostępnych kategorii oraz sposobu prezentacji danych. Oba narzędzia mają ten sam cel: ułatwienie wyszukiwania produktów.'
  },
  {
    question: 'Czy korzystanie z arkuszy jest bezpieczne?',
    answer: 'Korzystanie z arkuszy produktów jest bezpieczne, pod warunkiem zachowania podstawowych zasad: zawsze sprawdzaj linki przed kliknięciem, unikaj podejrzanych stron, chroń swoje dane osobowe i korzystaj tylko ze sprawdzonych źródeł. Arkusze same w sobie są jedynie narzędziem do organizacji informacji.'
  }
];